module.exports = __webpack_public_path__ + "img/icon-header-user-stat.49722da9.svg";